import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import ActivityTable from './ActivityTable.vue';
import { ActivityTableRecordType, Module } from '@/types';
import { store } from '@/plugins/store';

interface Props {
    recordTypeIds: ActivityTableRecordType[];
    heading: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityView',
  props: {
    recordTypeIds: { default: () => [] },
    heading: { default: '' }
  },
  setup(__props: any) {

const props = __props;

const filteredRecordTypeIds = computed(() => {
    const excludedIds: number[] = [];

    if (!store.getters.hasModuleEnabled(Module.Medicine)) {
        excludedIds.push(ActivityTableRecordType.Treatment);
    }

    return props.recordTypeIds.filter((id) => excludedIds.includes(id) === false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardContentLayout, {
    class: "space-y-8",
    heading: _ctx.$t(_ctx.heading),
    "has-period-picker": true,
    "has-pig-type-picker": true,
    slim: ""
  }, {
    default: _withCtx(() => [
      _createVNode(ActivityTable, { "selectable-record-type-ids": filteredRecordTypeIds.value }, null, 8, ["selectable-record-type-ids"])
    ]),
    _: 1
  }, 8, ["heading"]))
}
}

})